module.exports = __webpack_public_path__ + "static/media/studying-materials.07641486.jpg";